import { actions } from "./actions";
import { mutations } from "./mutations";
const state = {
    form: {},
    data: {},
    fieldInfoList: [],
    filters: null,
    listEntity: [],
    fieldTable: {},
    documents: [],
    fieldDocumentList: [],
    contacts: [],
    fieldContactList: [],
    bonusCards: [],
    fieldBonusCardList: [],
    tabnow: 'doc',
    
    visa: [],
    fieldVisaList: [],

    prefData: [],
    fieldprefDataList:[]
};

export default {
    state,
    actions,
    mutations
};